var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{ref:"mockSiteIframe",staticClass:"h-100 w-100",class:{'isDraggingOverIframe': _vm.isDragging},staticStyle:{"border":"none !important"},attrs:{"src":`/assets/mocksites/creativepreview-redux.html?tag=${_setup.tagToRender}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }